export default __webpack_public_path__ + "static/media/unileverLogo.5baf6e9c.png";